import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { getImagePath } from '../../utils/imagePath';

const Leadership = () => {
  const [activeTab, setActiveTab] = useState('current');

  // Current Leadership Team - Board Members (NEW TEAM with NewM images)
  const currentLeaders = [
    {
      name: 'Ogo Ewaoche',
      position: 'President',
      bio: 'Leading the club with vision and dedication to community excellence.',
      image: getImagePath('images/team/NewM1.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Chinedu Onyia',
      position: 'Vice President',
      bio: 'Committed to supporting the president and ensuring smooth club operations.',
      image: getImagePath('images/team/NewM2.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
     {
      name: 'Kayode Owaboye',
      position: 'General Secretary',
      bio: 'Managing club records and communications with precision and care.',
      image: getImagePath('images/team/NewM31.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Asolia Jumbo',
      position: 'Asst. General Secretary',
      bio: 'Managing club records and communications with precision and care.',
      image: getImagePath('images/team/NewM3.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Ifeoma Willie-Pepple',
      position: 'Treasurer',
      bio: 'Overseeing club finances with transparency and strategic planning.',
      image: getImagePath('images/team/NewM4.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
      {
      name: 'Chiedu Okoh',
      position: 'Auditor',
      bio: 'Overseeing club finances with transparency and strategic planning.',
      image: getImagePath('images/team/NewM41.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Temitayo Ogundoju',
      position: 'Director of Sports & Wellness',
      bio: 'Driving sports activities and promoting athletic excellence.',
      image: getImagePath('images/team/NewM5.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Augustina Sobo',
      position: 'Director of Culture',
      bio: 'Enriching club life through cultural events and activities.',
      image: getImagePath('images/team/NewM6.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Olujide Shoyebi',
      position: 'Director of Technical',
      bio: 'Ensuring technical excellence and facility maintenance.',
      image: getImagePath('images/team/NewM7.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Vikash Kumar',
      position: 'Director of International Affairs',
      bio: 'Bringing international perspective to club development.',
      image: getImagePath('images/team/NewM8.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Tajudeen Lasisi',
      position: 'Director of Social',
      bio: 'Organizing social events and fostering community connections.',
      image: getImagePath('images/team/NewM9.jpg'),
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  // Current Administrators (NEW with NewAdmin images)
  const currentAdministrators = [
    {
      name: 'Richard Chukwu',
      position: 'Club Manager',
      bio: 'Managing day-to-day club operations and member services.',
      image: getImagePath('images/team/NewAdmin1.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Paul Ovuche',
      position: 'Club Administrator',
      bio: 'Ensuring efficient administrative processes and member support.',
      image: getImagePath('images/team/NewAdmin2.jpg'),
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  // Past Leadership Team - Board Members (ORIGINAL images)
  const pastLeaders = [
    {
      name: 'Michael Ogbuanu',
      position: 'President',
      bio: 'Leading the club with vision and dedication to community excellence.',
      image: getImagePath('images/team/member-1.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Chinedu Onyia',
      position: 'Vice President',
      bio: 'Committed to supporting the president and ensuring smooth club operations.',
      image: getImagePath('images/team/member-2.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Linda Ogbu',
      position: 'Secretary',
      bio: 'Managing club records and communications with precision and care.',
      image: getImagePath('images/team/member-3.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Ifeoma Willie-Pepple',
      position: 'Treasurer',
      bio: 'Overseeing club finances with transparency and strategic planning.',
      image: getImagePath('images/team/member-8.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Chima Tasieobi',
      position: 'Sports Member',
      bio: 'Driving sports activities and promoting athletic excellence.',
      image: getImagePath('images/team/member-6.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Grace Ikufisile',
      position: 'Cultural Member',
      bio: 'Enriching club life through cultural events and activities.',
      image: getImagePath('images/team/member-4.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Buhari Bello',
      position: 'Technical Member',
      bio: 'Ensuring technical excellence and facility maintenance.',
      image: getImagePath('images/team/member-5.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Emiel Ten Velde',
      position: 'General Member (Expatriate)',
      bio: 'Bringing international perspective to club development.',
      image: getImagePath('images/team/member-7.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Osademe Azubike',
      position: 'Social Member',
      bio: 'Organizing social events and fostering community connections.',
      image: getImagePath('images/team/Img10.jpg'),
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  // Past Administrators (ORIGINAL images)
  const pastAdministrators = [
    {
      name: 'Richard Chukwu',
      position: 'Club Manager',
      bio: 'Managing day-to-day club operations and member services.',
      image: getImagePath('images/team/member-9.jpg'),
      social: { linkedin: '#', twitter: '#' }
    },
    {
      name: 'Paul Ovuche',
      position: 'Club Administrator',
      bio: 'Ensuring efficient administrative processes and member support.',
      image: getImagePath('images/team/member-91.jpg'),
      social: { linkedin: '#', twitter: '#' }
    }
  ];

  const styles = {
    // Page Container
    leadershipPage: {
      background: '#f8f9fa',
      minHeight: '100vh',
    },

    // Hero Section
    pageHero: {
      position: 'relative',
      background: 'linear-gradient(135deg, #1a3a4a 0%, #2d5a6d 100%)',
      padding: '120px 0 80px',
      overflow: 'hidden',
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(26, 58, 74, 0.95) 0%, rgba(45, 90, 109, 0.85) 100%)',
    },
    heroContent: {
      position: 'relative',
      zIndex: 2,
      textAlign: 'center',
    },
    heroEyebrow: {
      display: 'inline-block',
      background: 'rgba(255, 255, 255, 0.15)',
      color: '#fff',
      padding: '8px 20px',
      borderRadius: '50px',
      fontSize: '14px',
      fontWeight: 600,
      letterSpacing: '2px',
      textTransform: 'uppercase',
      marginBottom: '20px',
    },
    heroTitle: {
      fontSize: '52px',
      fontWeight: 700,
      color: '#fff',
      marginBottom: '20px',
    },
    textGreen: {
      color: '#4CAF50',
    },
    heroSubtitle: {
      fontSize: '20px',
      color: 'rgba(255, 255, 255, 0.85)',
      maxWidth: '600px',
      margin: '0 auto',
      lineHeight: 1.6,
    },

    // Tabs Section
    tabsSection: {
      background: '#ffffff',
      padding: '40px 0',
      boxShadow: '0 2px 20px rgba(0, 0, 0, 0.06)',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    },
    tabsWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    tabNavigation: {
      display: 'inline-flex',
      background: '#f0f2f5',
      borderRadius: '60px',
      padding: '6px',
      gap: '4px',
    },
    tabBtn: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '14px 32px',
      border: 'none',
      background: 'transparent',
      borderRadius: '50px',
      fontSize: '16px',
      fontWeight: 600,
      color: '#6c7a8a',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
    },
    tabBtnActive: {
      background: '#ffffff',
      color: '#1a3a4a',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
    },
    tabIcon: {
      fontSize: '18px',
      transition: 'all 0.3s ease',
    },
    tabLabel: {
      transition: 'all 0.3s ease',
    },
    tabBadge: {
      background: '#e0e4e8',
      color: '#6c7a8a',
      padding: '2px 10px',
      borderRadius: '30px',
      fontSize: '11px',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      transition: 'all 0.3s ease',
    },
    tabBadgeActive: {
      background: '#4CAF50',
      color: '#ffffff',
    },

    // Section Headers
    sectionHeader: {
      textAlign: 'center',
      marginBottom: '50px',
    },
    sectionEyebrow: {
      display: 'inline-block',
      color: '#4CAF50',
      fontSize: '14px',
      fontWeight: 600,
      letterSpacing: '3px',
      textTransform: 'uppercase',
      marginBottom: '12px',
    },
    sectionTitle: {
      fontSize: '38px',
      fontWeight: 700,
      color: '#1a3a4a',
      marginBottom: '16px',
    },
    sectionSubtitle: {
      fontSize: '18px',
      color: '#6c7a8a',
      maxWidth: '600px',
      margin: '0 auto',
      lineHeight: 1.6,
    },

    // Sections
    leadershipSection: {
      padding: '80px 0',
    },
    administratorsSection: {
      padding: '80px 0',
      background: '#f8f9fa',
    },

    // Container
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
    },

    // Grids
    leadershipGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '35px',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    administratorsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      gap: '35px',
      maxWidth: '800px',
      margin: '0 auto',
    },

    // Leader Card
    leaderCard: {
      background: '#ffffff',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
      transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
    },
    leaderImageWrapper: {
      position: 'relative',
      width: '100%',
      paddingTop: '120%',
      overflow: 'hidden',
      background: '#f0f2f5',
    },
    leaderImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
    leaderImageImg: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)',
    },
    imageOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(0deg, rgba(26, 58, 74, 0.7) 0%, transparent 60%)',
      opacity: 0,
      transition: 'opacity 0.4s ease',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      padding: '20px',
    },
    leaderSocial: {
      display: 'flex',
      gap: '12px',
      transform: 'translateY(20px)',
      transition: 'transform 0.4s ease',
    },
    socialLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '40px',
      height: '40px',
      background: 'rgba(255, 255, 255, 0.9)',
      borderRadius: '50%',
      color: '#1a3a4a',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
    },
    leaderInfo: {
      padding: '25px 25px 30px',
      textAlign: 'center',
    },
    leaderName: {
      fontSize: '20px',
      fontWeight: 700,
      color: '#1a3a4a',
      marginBottom: '6px',
    },
    leaderPosition: {
      fontSize: '14px',
      color: '#4CAF50',
      fontWeight: 600,
      marginBottom: '12px',
    },
    leaderDivider: {
      width: '40px',
      height: '3px',
      background: 'linear-gradient(90deg, #4CAF50, #66BB6A)',
      margin: '12px auto',
      borderRadius: '3px',
    },
    leaderBio: {
      fontSize: '14px',
      lineHeight: 1.6,
      color: '#6c7a8a',
      margin: 0,
    },
  };

  return (
    <div style={styles.leadershipPage}>
      {/* Hero Section */}
      <section style={styles.pageHero}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.container}>
          <motion.div 
            style={styles.heroContent}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span style={styles.heroEyebrow}>THE CLUB</span>
            <h1 style={styles.heroTitle}>
              Leadership <span style={styles.textGreen}>Team</span>
            </h1>
            <p style={styles.heroSubtitle}>
              Meet the dedicated individuals guiding NLNG RA Club towards excellence
            </p>
          </motion.div>
        </div>
      </section>

      {/* Tab Navigation */}
      <section style={styles.tabsSection}>
        <div style={styles.container}>
          <div style={styles.tabsWrapper}>
            <div style={styles.tabNavigation}>
              <button 
                style={{
                  ...styles.tabBtn,
                  ...(activeTab === 'current' ? styles.tabBtnActive : {})
                }}
                onClick={() => setActiveTab('current')}
              >
                <span style={styles.tabIcon}>
                  <i className="fas fa-users"></i>
                </span>
                <span style={styles.tabLabel}>Current Excos</span>
                <span style={{
                  ...styles.tabBadge,
                  ...(activeTab === 'current' ? styles.tabBadgeActive : {})
                }}>New</span>
              </button>
              <button 
                style={{
                  ...styles.tabBtn,
                  ...(activeTab === 'past' ? styles.tabBtnActive : {})
                }}
                onClick={() => setActiveTab('past')}
              >
                <span style={styles.tabIcon}>
                  <i className="fas fa-history"></i>
                </span>
                <span style={styles.tabLabel}>Past Excos</span>
                <span style={{
                  ...styles.tabBadge,
                  ...(activeTab === 'past' ? styles.tabBadgeActive : {})
                }}>Legacy</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Current Tab Content */}
      {activeTab === 'current' && (
        <>
          <section style={styles.leadershipSection}>
            <div style={styles.container}>
              <div style={styles.sectionHeader}>
                <span style={styles.sectionEyebrow}>RA Club Executive Committee (RCEC)</span>
                <h2 style={styles.sectionTitle}>
                  Current <span style={styles.textGreen}>Leadership</span>
                </h2>
                <p style={styles.sectionSubtitle}>
                  Experienced professionals committed to serving our community with excellence
                </p>
              </div>

              <div style={styles.leadershipGrid}>
                {currentLeaders.map((leader, index) => (
                  <motion.div 
                    key={index}
                    style={styles.leaderCard}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ y: -8 }}
                  >
                    <div style={styles.leaderImageWrapper}>
                      <div style={styles.leaderImage}>
                        <img 
                          src={leader.image} 
                          alt={leader.name}
                          style={styles.leaderImageImg}
                        />
                        <div style={styles.imageOverlay}>
                          <div style={styles.leaderSocial}>
                            <a href={leader.social.linkedin} style={styles.socialLink}>
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href={leader.social.twitter} style={styles.socialLink}>
                              <i className="fab fa-twitter"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.leaderInfo}>
                      <h3 style={styles.leaderName}>{leader.name}</h3>
                      <p style={styles.leaderPosition}>{leader.position}</p>
                      <div style={styles.leaderDivider}></div>
                      <p style={styles.leaderBio}>{leader.bio}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>

          <section style={styles.administratorsSection}>
            <div style={styles.container}>
              <div style={styles.sectionHeader}>
                <span style={styles.sectionEyebrow}>ADMINISTRATIVE TEAM</span>
                <h2 style={styles.sectionTitle}>
                  Club <span style={styles.textGreen}>Administrators</span>
                </h2>
                <p style={styles.sectionSubtitle}>
                  Dedicated professionals ensuring smooth club operations
                </p>
              </div>

              <div style={styles.administratorsGrid}>
                {currentAdministrators.map((admin, index) => (
                  <motion.div 
                    key={index}
                    style={styles.leaderCard}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ y: -8 }}
                  >
                    <div style={styles.leaderImageWrapper}>
                      <div style={styles.leaderImage}>
                        <img 
                          src={admin.image} 
                          alt={admin.name}
                          style={styles.leaderImageImg}
                        />
                        <div style={styles.imageOverlay}>
                          <div style={styles.leaderSocial}>
                            <a href={admin.social.linkedin} style={styles.socialLink}>
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href={admin.social.twitter} style={styles.socialLink}>
                              <i className="fab fa-twitter"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.leaderInfo}>
                      <h3 style={styles.leaderName}>{admin.name}</h3>
                      <p style={styles.leaderPosition}>{admin.position}</p>
                      <div style={styles.leaderDivider}></div>
                      <p style={styles.leaderBio}>{admin.bio}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>
        </>
      )}

      {/* Past Tab Content */}
      {activeTab === 'past' && (
        <>
          <section style={styles.leadershipSection}>
            <div style={styles.container}>
              <div style={styles.sectionHeader}>
                <span style={styles.sectionEyebrow}>PAST RA Club Executive Committee (RCEC)</span>
                <h2 style={styles.sectionTitle}>
                  Previous <span style={styles.textGreen}>Leadership</span>
                </h2>
                <p style={styles.sectionSubtitle}>
                  Honoring the contributions of our former executive committees
                </p>
              </div>

              <div style={styles.leadershipGrid}>
                {pastLeaders.map((leader, index) => (
                  <motion.div 
                    key={index}
                    style={styles.leaderCard}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ y: -8 }}
                  >
                    <div style={styles.leaderImageWrapper}>
                      <div style={styles.leaderImage}>
                        <img 
                          src={leader.image} 
                          alt={leader.name}
                          style={styles.leaderImageImg}
                        />
                        <div style={styles.imageOverlay}>
                          <div style={styles.leaderSocial}>
                            <a href={leader.social.linkedin} style={styles.socialLink}>
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href={leader.social.twitter} style={styles.socialLink}>
                              <i className="fab fa-twitter"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.leaderInfo}>
                      <h3 style={styles.leaderName}>{leader.name}</h3>
                      <p style={styles.leaderPosition}>{leader.position}</p>
                      <div style={styles.leaderDivider}></div>
                      <p style={styles.leaderBio}>{leader.bio}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>

          <section style={styles.administratorsSection}>
            <div style={styles.container}>
              <div style={styles.sectionHeader}>
                <span style={styles.sectionEyebrow}>PAST ADMINISTRATIVE TEAM</span>
                <h2 style={styles.sectionTitle}>
                  Previous <span style={styles.textGreen}>Administrators</span>
                </h2>
                <p style={styles.sectionSubtitle}>
                  Recognizing the dedication of our former administrative staff
                </p>
              </div>

              <div style={styles.administratorsGrid}>
                {pastAdministrators.map((admin, index) => (
                  <motion.div 
                    key={index}
                    style={styles.leaderCard}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ y: -8 }}
                  >
                    <div style={styles.leaderImageWrapper}>
                      <div style={styles.leaderImage}>
                        <img 
                          src={admin.image} 
                          alt={admin.name}
                          style={styles.leaderImageImg}
                        />
                        <div style={styles.imageOverlay}>
                          <div style={styles.leaderSocial}>
                            <a href={admin.social.linkedin} style={styles.socialLink}>
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href={admin.social.twitter} style={styles.socialLink}>
                              <i className="fab fa-twitter"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.leaderInfo}>
                      <h3 style={styles.leaderName}>{admin.name}</h3>
                      <p style={styles.leaderPosition}>{admin.position}</p>
                      <div style={styles.leaderDivider}></div>
                      <p style={styles.leaderBio}>{admin.bio}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Leadership;